import {useIsMobile, useMediaQuery} from '@/hooks';
import {ContentBlockFieldsFragment} from '@common/hygraph-schema';
import {Box, Flex, Stack} from '@panda/jsx';
import {PropsWithChildren} from 'react';
import {Button, Text} from '@/components';
import {css} from '@panda/css';
import {EventAction} from '@/types/analytics.types';

const Heading = ({
	heading,
	button: buttonProps
}: Pick<ContentBlockFieldsFragment, 'heading' | 'button'>) => {
	const isDeviceMobile = useIsMobile();
	const isMediaMobile = useMediaQuery('mdDown');
	const isMobile = isDeviceMobile || isMediaMobile;
	const head = heading ? (
		<Text {...heading} variant={isMobile ? 'headingLG' : heading.textVariant} />
	) : null;

	const button = buttonProps ? (
		<Button
			{...buttonProps}
			analytics={{
				eventAction: buttonProps.ukey as EventAction,
				eventLabel: buttonProps.btnLabel
			}}
			className={css({
				alignItems: 'flex-end !important',
				'&:hover': {
					textDecoration: 'none !important',
					color: 'inherit !important'
				},
				mdDown: {
					maxWidth: '100% !important',
					width: '100% !important'
				}
			})}
		/>
	) : null;
	return (
		<Flex
			className={css({
				gap: '16px',
				alignItems: 'center',
				justifyContent: 'space-between',
				mdDown: {flexDirection: 'column'}
			})}>
			{isMobile ? button : head}
			{isMobile ? head : button}
		</Flex>
	);
};

// This component is currently only used for masthead in ContentBlock Section.
export const ContentBlock = ({
	heading,
	subheading,
	button,
	children
}: PropsWithChildren<ContentBlockFieldsFragment>) => {
	return (
		<Stack gap={4}>
			<Heading heading={heading} button={button} />
			{subheading && (
				<Box pb="8px">
					<Text {...subheading} variant={subheading.textVariant || 'paragraphMD'} />
				</Box>
			)}

			{children}
		</Stack>
	);
};
